import styles from "./styles";

const PrivacyPageElement = () => {
    return (
        <div style={styles.body} dir="ltr">
            <div style={styles.policyContainer}>
                <h1 style={styles.h1}>Privacy Policy</h1>
                <p style={styles.lastUpdated}>Last Updated: December 31, 2025</p>

                <section>
                    <h2 style={styles.h2}>1. Introduction</h2>
                    <p>Welcome to <strong>Microspec</strong> (<a href="https://microspec.io" style={styles.link}>https://microspec.io</a>). We value your privacy and are committed to protecting your personal data. This policy explains how we collect, use, and store your information when you use our services.</p>
                    <p>By using our website and services, you acknowledge the practices described in this policy. Our business is located and operated in <strong>Sakhnin, Israel</strong>.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>2. Information We Collect</h2>
                    <p>We only collect information that is strictly necessary to fulfill your orders and provide our services.</p>

                    <h3 style={styles.h3}>A. Information You Provide to Us</h3>
                    <p>When you place an order or create an account, we may collect:</p>
                    <ul style={styles.ul}>
                        <li style={styles.li}><strong>Contact Details:</strong> Name, email address, and phone number.</li>
                        <li style={styles.li}><strong>Delivery Information:</strong> Physical address and, in specific cases, <strong>GPS location data</strong> to ensure accurate delivery of your order.</li>
                    </ul>

                    <h3 style={styles.h3}>B. Information Collected Automatically</h3>
                    <p>We do <strong>not</strong> use third-party tracking tools like Google Analytics or Facebook Pixel. However, for technical security and website functionality, our servers may temporarily log basic technical data such as your IP address, browser type, and device type.</p>

                    <h3 style={styles.h3}>C. Children's Privacy</h3>
                    <p>Our services are not intended for children under the age of 13. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>3. How We Use and Share Your Data</h2>
                    
                    <h3 style={styles.h3}>A. How We Use Your Data</h3>
                    <p>We use your data solely for the following purposes:</p>
                    <ul style={styles.ul}>
                        <li style={styles.li}>To process and deliver your orders (specifically using your address/GPS location).</li>
                        <li style={styles.li}>To communicate with you regarding your order status.</li>
                        <li style={styles.li}>To maintain the security of our website.</li>
                    </ul>

                    <h3 style={styles.h3}>B. Marketing and Payments</h3>
                    <ul style={styles.ul}>
                        <li style={styles.li}><strong>No Marketing:</strong> We do not send marketing emails, newsletters, or promotional offers. We will only email you regarding your specific orders or account security.</li>
                        <li style={styles.li}><strong>No Online Payments:</strong> We do not currently process payments online or store credit card information on our servers.</li>
                    </ul>

                    <h3 style={styles.h3}>C. Sharing Your Data</h3>
                    <p>We do <strong>not</strong> sell or rent your personal data to anyone. We only share data with trusted third parties necessary to operate our business, such as:</p>
                    <ul style={styles.ul}>
                        <li style={styles.li}><strong>Delivery Partners:</strong> We may share your name, phone number, and location with delivery drivers or courier services to fulfill your order.</li>
                    </ul>
                </section>

                <section>
                    <h2 style={styles.h2}>4. Data Protection & Your Rights</h2>
                    
                    <h3 style={styles.h3}>Security</h3>
                    <p>We implement accepted industry standards to protect the information submitted to us. While no method of transmission over the Internet is 100% secure, we strive to use commercially acceptable means to protect your personal data.</p>

                    <h3 style={styles.h3}>Data Retention</h3>
                    <p>We retain your personal information only as long as necessary to provide our services. However, if you request that we delete your data, we will do so immediately, subject to any legal requirements (such as tax laws) that may require us to keep transaction records.</p>

                    <h3 style={styles.h3}>Your Rights</h3>
                    <p>Under Israeli law and general privacy principles, you have the right to:</p>
                    <ul style={styles.ul}>
                        <li style={styles.li}><strong>Inspect:</strong> Ask to see the data we hold about you.</li>
                        <li style={styles.li}><strong>Correct:</strong> Ask us to fix incorrect information.</li>
                        <li style={styles.li}><strong>Delete:</strong> Request that we completely remove your personal data from our systems.</li>
                    </ul>
                    <p>To exercise any of these rights, please contact us at the email address below.</p>
                </section>

                <section>
                    <h2 style={styles.h2}>5. Contact Us</h2>
                    <p>If you have questions about this policy or wish to exercise your rights to delete your data, please contact us:</p>
                    
                    <div style={styles.contactBox}>
                        <p><strong>Email:</strong> <a href="mailto:support@microspec.io" style={styles.link}>support@microspec.io</a></p>
                        <p><strong>Physical Address:</strong> Sakhnin 3081000, Northern District, Israel.</p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPageElement;